export const privacyData = {
  title: "Datenschutzerklärung",
  content: [
    {
      title: "1. Allgemeine Hinweise",
      text: "Wir freuen uns über Deinen Besuch auf unserer Website und Dein Interesse an unseren Inhalten. Der Schutz Deiner persönlichen Daten ist uns sehr wichtig. Diese Datenschutzerklärung informiert Dich über die Erhebung und Verwendung von personenbezogenen Daten im Zusammenhang mit der Nutzung unserer Website."
    },
    {
      title: "2. Verantwortliche Stelle",
      text: "Verantwortliche Stelle für die Verarbeitung der Daten ist:",
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf',
        'E-Mail: kontakt@robinwichmann.com'
      ],
      type: 'address'
    },
    {
      title: "3. Keine personenbezogenen Daten",
      text: "Unsere Website sammelt keine personenbezogenen Daten wie Name, E-Mail-Adresse oder andere persönliche Informationen. Wir speichern keine Nutzerdaten und setzen keine Tracking-Cookies oder ähnliches ein."
    },
    {
      title: "4. Cloudflare Web Analytics",
      text: "Wir verwenden Cloudflare Web Analytics, ein datenschutzfreundliches Web-Analyse-Tool, das uns hilft, allgemeine Statistiken über die Nutzung unserer Website zu erstellen.\n\nCloudflare Web Analytics setzt keine Cookies und erhebt keine personenbezogenen Daten.\n\nDie erhobenen Daten umfassen Seitenaufrufe, geografische Herkunft (Land), Browser und Gerätetyp, jedoch keine detaillierten oder personalisierten Informationen.\n\nWeitere Informationen zum Datenschutz von Cloudflare findest Du in der Datenschutzerklärung von Cloudflare."
    },
    {
      title: "5. Keine Nutzung von Cookies",
      text: "Unsere Website verwendet keine Cookies und es werden keine personenbezogenen Daten gesammelt oder gespeichert."
    },
    {
      title: "6. Sicherheitsmaßnahmen",
      text: "Wir treffen alle erforderlichen technischen und organisatorischen Maßnahmen, um Deine Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen. Da es sich um eine statische Website handelt, sind jedoch keine personenbezogenen Daten im Spiel, und die von uns verwendeten Tools sind auf den Schutz der Privatsphäre der Nutzer ausgelegt."
    },
    {
      title: "7. Links zu anderen Websites",
      text: "Unsere Website kann Links zu externen Websites enthalten. Wir haben keinen Einfluss auf die Inhalte dieser Seiten und übernehmen keine Verantwortung für deren Datenschutzpraktiken. Bitte beachte, dass für diese Seiten jeweils die Datenschutzbestimmungen des jeweiligen Anbieters gelten."
    },
    {
      title: "8. Deine Rechte",
      text: "Da wir keine personenbezogenen Daten erheben, benötigst Du keine Maßnahmen zur Kontrolle Deiner Daten. Wenn Du dennoch Fragen zu Deiner Privatsphäre oder dem Datenschutz hast, kannst Du uns jederzeit kontaktieren."
    },
    {
      title: "9. Änderungen dieser Datenschutzerklärung",
      text: "Wir behalten uns vor, diese Datenschutzerklärung jederzeit zu ändern, um sie an gesetzliche Anforderungen anzupassen oder Änderungen an unseren Leistungen umzusetzen. Es gilt stets die aktuelle Version dieser Datenschutzerklärung."
    }
  ]
}; 